<template>
<div class="full">
  <div v-show="!ready" class="loader"/>
  <div id="app" class="full" v-bind:class="{hidden:!ready}">
    <iframe id="main" ref="mainframe" v-bind:class="{hidden:loading}" @load="load" width="100%" height="100%"></iframe>
    <div id="left-pannel" class="h-sep">
      <div class="box-fill v-sep">
        <header id="header">
          <h1 class="title">{{title}}</h1>
          <vue-markdown :source="poem" class="poem"></vue-markdown>
        </header>
        <div id="scrollbar" class="box-fill v-sep scroll-y">
          <card v-for="p in pictures"
          :key="p.id" :title="p.title"
          :description="p.description"
          :vignettePath="p.vignette"
          :current="current"
          :loading="loading"
          :id="p.id"
          :draft="p.draft"
          v-on:selectCurrent="currentChange" />
        </div>
      </div>
      <div id="slide">
      </div>
    </div>
  </div>

</div>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'
import card from './components/card.vue'
import * as pData from "./assets/picturesData.JSON";
import poem from 'raw-loader!./poem.md';


export default {
  name: 'app',
  components: {
    VueMarkdown,
    card
  },
  data() {
    return {
      title: "Intimacy",
      pictures: pData.default,
      loading: true,
      ready: false,
      current: 0,
      poem: poem,
    }
  },
  methods: {
    currentChange: function(id, draft) {
      if (this.loading) return false;
      if (draft) return false;
      this.loading = true;
      this.current = id;
      setTimeout(() => {
        this.$refs.mainframe.src = this.pictures[this.current].path;
      }, 1000);

    },
    load: function() {
      this.loading = false;
    }
  },
  mounted: function() {
    setTimeout(()=>{
      this.ready = true;
    },1000);
    this.loading = true;
    this.$refs.mainframe.src = this.pictures[this.current].path;
  }

}
</script>

<style>
@font-face {
  font-family: "Quicksand";
  src: url("./fonts/Quicksand-Light.ttf");
  font-weight: 200;
  font-style: normal;
}

html,
body {
  height: 100%;
  font-size: 100%;
}

body {
  margin: 0;
  font-family: sans-serif;
  overflow: hidden;
  user-select: none;
  font-size: 0.8rem;
  background-color: black;
  color:white;
}

#app{
  transition: all 0.2s;
  perspective: 1000px;
  background-image: radial-gradient(ellipse at bottom center, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 1) 60%), url("./assets/5-dots.png");
}

h1,
h2,
h3,
h4,
h5 {
  font-family: "Quicksand";
}

iframe {
  border: 0;
  opacity: 1;
  transition: opacity 0.6s, transform 0.8s, filter 0.4s;
}

.hidden {
  opacity: 0;
  filter: grayscale(1);
  transform: scale(1.04);
}


.full {
  width: 100%;
  height: 100%;
}

.box-fill {
  flex: 1;
}

.h-sep {
  display: flex;
  flex-direction: row;
}

.v-sep {
  display: flex;
  flex-direction: column;
}

.v-sep.v-center {
  justify-content: center;
}

.h-sep.v-center {
  align-items: center;
}

.h-sep.gap>* {
  margin-left: 1rem;
}

.h-sep.gap>*:first-child {
  margin-left: 0;
}

.scroll-y {
  position: relative;
  overflow-y: scroll;
  padding-right: 1.2rem;
  margin-bottom: 1rem;
  scrollbar-color: rgba(255, 255, 255, 1) rgba(255, 255, 255, 0.2);
  scrollbar-width: thin;
  scrollbar-corner: round;
}

#left-pannel {
  z-index: 2;
  box-sizing: border-box;
  position: absolute;
  width: 10%;
  min-width: 56ch;
  height: 100%;
  background-color: black;
  color: white;
  transform: translateX(calc(-100% + 20px));
  transition: all 0.6s;
}

#main {
  position: absolute;
}

#main:not(:hover)~#left-pannel {
  transform: translateX(0);
}

#slide {
  width: 20px;
  background-image: url("./assets/lines_icon.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
}

#header {
  padding: 0.2rem 1.8rem;
  background-image: radial-gradient(ellipse at top left, rgba(0, 0, 0, 0.2) 30%, rgba(0, 0, 0, 1)), url("./assets/5-dots.png");
  margin-bottom: 2rem;
}

#header .title {
  text-transform: uppercase;
}

#header .poem {
  font-family: monospace;
  font-size: 1rem;
  line-height: 1.4rem;
}


[class*="scroll"]::-webkit-scrollbar {
  width: 2px;
  border-radius: 6px;
}

[class*="scroll"]::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;

}

[class*="scroll"]::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 6px;

}

.loader{
  position: absolute;
  left:50%;
  top:50%;
  animation: spin 0.3s infinite linear;
  perspective: 100px;
  width:32px;
  height: 32px;

}
.loader::after{
  content: "";
  position: absolute;
  width:8px;
  height: 8px;
  background-color: white;
  border-radius: 50%;
  top: 50%;
  left:0;
  transform: translate(-50%,-50%);
}
.loader::before{
  box-sizing: border-box;
  content: "";
  position: absolute;
  border: 1.5px solid white;
  border-radius: 50%;
  width:100%;
  height: 100%;
}
@keyframes spin {
  from{
  }
  to{
    transform: rotateZ(360deg);
  }
}
</style>
